import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from "../../../../../environments/environment";
import { ClaimModel } from "../interfaces/claim.model";
import { Observable } from "rxjs";
import { AuthService } from "../../../../core/service/auth.service";
import { CheckClaimStatusResponse } from "../interfaces/claim-status.interface";

@Injectable({
  providedIn: 'root'
})
export class ClaimService {
  private apiUrl = environment.apiUrl;

  private http = inject(HttpClient);
  private authService = inject(AuthService);

  reportProblem(claimModel: ClaimModel): Observable<{ success: boolean, message: string }> {
    const token = this.authService.getToken();

    const formData = new FormData();
    formData.append('id_order', String(claimModel.id_order));
    formData.append('type', String(claimModel.type));
    formData.append('description', claimModel.description);
    if (claimModel.image) {
      formData.append('image', claimModel.image);
    }

    return this.http.post<{ success: boolean, message: string }>(
      `${this.apiUrl}/register-issue`,
      formData,
      { headers: { 'Authorization': `Bearer ${token}` } }
    );
  }

  checkStatusClaim(idOrder: number): Observable<CheckClaimStatusResponse> {
    const token = this.authService.getToken();
    return this.http.get<CheckClaimStatusResponse>(
      `${this.apiUrl}/getIssue/${idOrder}`,
      { headers: { 'Authorization': `Bearer ${token}` } }
    );
  }
}
